import script from "./contact-form-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-form-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__